import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import LoadingCentered from "../../common/loaders/loadingcentered";
import { generatePdfReport } from "../../api";
import { authSelector } from "../../reducers";
import { blobToDataURL, logoFetch, logoUrl } from "../../common/utils";

export function PdfDiscussion({ data, setPdf }) {
  const { t } = useTranslation();
  const [objectURL, setObjectURL] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const { companyName, companyAddress1, companyAddress2, companyAddress3, companyEmail, companyUrl, companyLogoUrl, company } = useSelector(authSelector);
  const organizationLogoUrl = company?.logoUrl;

  const hide = () => setPdf(null);

  useEffect(() => {
    async function fetchReport() {
      setObjectURL("");
      setShowLoading(true);
      const json = {
        ...data,
        company: {
          name: companyName,
          address1: companyAddress1,
          address2: companyAddress2,
          address3: companyAddress3,
          email: companyEmail,
          url: companyUrl,
          logo: await logoFetch( logoUrl(companyLogoUrl, organizationLogoUrl) ),
        },
      };

      const res = await generatePdfReport("keskustelu", json);
      setObjectURL(URL.createObjectURL(res.data));
      setShowLoading(false);
      //window.open(objectURL, "_blank");
    }
    fetchReport();
  }, [data]);

  return (
    <Modal show onHide={hide} size="xl" fullscreen="lg-down">
      <Modal.Header closeButton>{t("PdfPreview", "Pdf-esikatselu")}</Modal.Header>
      <LoadingCentered show={showLoading} />
      <iframe style={{ height: "85vh" }} src={objectURL} />
    </Modal>
  );
}
